import API from './apiConfig';

const AUDIT_API = '/audit';

export const getTransactionAuditLogs = async (transactionId) => {
  const res = await API.get(AUDIT_API + `/transaction/${transactionId}`, {
    withCredentials: true,
  });
  return res.data;
};

export const getInvoicesAuditLogs = async (invoiceId) => {
  const res = await API.get(AUDIT_API + `/invoice/${invoiceId}`, {
    withCredentials: true,
  });
  return res.data;
};

export const getPayoutsAuditLogs = async (payoutId) => {
  const res = await API.get(AUDIT_API + `/payout/${payoutId}`, {
    withCredentials: true,
  });
  return res.data;
};

let controller = null;
export const getAuditLog = async (payload) => {
  if (controller) {
    controller.abort();
  }
  controller = new AbortController();
  const res = await API.get(AUDIT_API + `/auditLogs`, {
    withCredentials: true,
    params: payload,
    signal: controller.signal,
  });
  return res?.data;
};

export const getAuditExport = async (payload) => {
  const response = await API.get(AUDIT_API + '/auditLogExportSync', {
    headers: {
      'Content-Type': 'application/json',
    },
    params: payload,
    responseType: 'blob',
    withCredentials: true,
    timeout: 1000 * 60 * 15,
  });
  return response.data;
};
